import { startCase } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";

import { MessagesDisplayItemStyled } from "./messages-display.container.styled";
import { IMessagesType } from "./messages-display.models";
import { MessagesIndicatorConst } from "./messages-display.utils";

interface IMessagesDisplayItem {
  messageDescription: string;
  type: IMessagesType;
}

export const MessagesDisplayItem: FC<IMessagesDisplayItem> = ({
  messageDescription,
  type,
}) => {
  const { t } = useTranslation();
  const translatedMessage = t(messageDescription);
  const messageDescriptionCapitalized =
    translatedMessage === messageDescription
      ? startCase(messageDescription ?? "")
      : translatedMessage;
  const { $color, $iconColor } = MessagesIndicatorConst[type];

  return (
    <MessagesDisplayItemStyled $color={$color}>
      <SVG_MUI.BellFilled color={$iconColor} />
      <span> {messageDescriptionCapitalized}</span>
    </MessagesDisplayItemStyled>
  );
};
